import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { selectChatHistoryServ, getChatsMessagesServ } from './historyApi';

const initialState = {
  list: null,
  messagesList: new Map(),
  loading: false,
  count: 0,
  status: 'idle'
}

export const selectHistory = createAsyncThunk(
  'select_chat_history',
  async ({partnerId, queryData={}})=> {
    const res = await selectChatHistoryServ(partnerId, queryData);
    if(res.success) {
      return res;
    }
    throw new Error('Get chats history failed!', res.message);
  }
);

export const getChatMessages = createAsyncThunk(
  'get_chat_messages',
  async ({partnerId, chatId})=> {
    const res = await getChatsMessagesServ(partnerId, chatId);
    if(res.success) {
      return {
        data: res.data,
        logs: res.logs,
        chatId
      };
    }
    throw new Error('Get chats Chat Messages failed!', res.message);
  }
);

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    clearHistoryMessageFile: (state, action) => {
      const { chatId, messageId } = action.payload;
      const idStr = String(messageId);

      if (Array.isArray(state.list)) {
        state.list = state.list.map((chat) => {
          if (String(chat._id) !== String(chatId) || !Array.isArray(chat.messages)) return chat;
          return {
            ...chat,
            messages: chat.messages.map((m) =>
              String(m._id || m.id) === idStr ? { ...m, file: '' } : m
            ),
          };
        });
      }

      const stored = state.messagesList.get(chatId);
      if (stored?.data && Array.isArray(stored.data)) {
        state.messagesList = state.messagesList.set(chatId, {
          ...stored,
          data: stored.data.map((m) =>
            String(m._id || m.id) === idStr ? { ...m, file: '' } : m
          ),
        });
      } else if (Array.isArray(stored)) {
        state.messagesList = state.messagesList.set(
          chatId,
          stored.map((m) =>
            String(m._id || m.id) === idStr ? { ...m, file: '' } : m
          )
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(selectHistory.pending, (state) => {
        state.status = 'loading';
        state.loading = true
      })
      .addCase(selectHistory.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload.data;
        state.count = action.payload.count;
        state.loading = false;
      })
      .addCase(selectHistory.rejected, (state, action) => {
        state.status = 'error';
        state.loading = false;
        console.error("Error redux async func 'selectHistory'", action.error)
      })
      .addCase(getChatMessages.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getChatMessages.fulfilled, (state, action) => {
        state.status = 'idle';
        state.messagesList = state.messagesList.set(action.payload.chatId, {
          data: action.payload.data,
          logs: action.payload.logs || [],
        });
      })
      .addCase(getChatMessages.rejected, (state, action) => {
        state.status = 'error';
        console.error("Error redux async func 'getChatMessages'", action.error)
      })
  },
});

export const { clearHistoryMessageFile } = historySlice.actions;
export const selectBanned = (state) => state.history;
export default historySlice.reducer;